import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import IosShareIcon from "@mui/icons-material/IosShare";
import { exportVisibleColumnsAsXls } from "../utilities/exportVisibleColumnsAsXls";

const ExportButton = ({
  table,
  tooltipTitle,
  trackActivity,
  userId,
  exportColumns,
  fileName,
  worksheetName,
}) => {
  const handleExport = () => {
    trackActivity({
      Type: "Export",
      CreatedBy: userId,
      ItemId: null,
      Value: fileName,
    });

    exportVisibleColumnsAsXls({
      table,
      exportColumns,
      fileName,
      worksheetName,
    });
  };

  return (
    <Tooltip title={tooltipTitle} arrow>
      <IconButton
        onClick={handleExport}
        size="medium"
        sx={{
          "&:hover": {
            opacity: 0.7,
          },
        }}
      >
        <IosShareIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ExportButton;
